var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { Subject } from "rxjs";
export var agreementModalSubject = new Subject();
var AgreementModal = function (props) {
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = useState(false), hasScrolledToBottom = _b[0], setHasScrolledToBottom = _b[1];
    var bodyRef = useRef(null);
    useEffect(function () {
        var subscription = agreementModalSubject.subscribe(function (obj) {
            if (obj) {
                setShowModal(obj);
                setHasScrolledToBottom(false);
            }
            else {
                closeModal();
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, []);
    useEffect(function () {
        var checkIfScrollable = function () {
            if (bodyRef.current) {
                var _a = bodyRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
                if (scrollHeight <= clientHeight) {
                    setHasScrolledToBottom(true);
                }
            }
        };
        var timer = setTimeout(checkIfScrollable, 100);
        return function () { return clearTimeout(timer); };
    }, [showModal]);
    var handleScroll = function () {
        if (bodyRef.current) {
            var _a = bodyRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - 5) {
                setHasScrolledToBottom(true);
            }
        }
    };
    var closeModal = function () {
        if (showModal && showModal.onClose) {
            showModal.onClose();
        }
        setShowModal(false);
    };
    if (showModal) {
        return (_jsxs(_Fragment, { children: [props.children, _jsxs("div", __assign({ className: "modal show agreement-modal ".concat(showModal.class || ""), style: {
                        width: showModal.width ? showModal.width : "auto",
                        maxWidth: showModal.width ? "calc(100vw - 40px)" : "",
                    } }, { children: [showModal.title && (_jsx("div", __assign({ className: "header" }, { children: showModal.title }))), _jsx("div", { ref: bodyRef, onScroll: handleScroll, className: "body", style: {
                                maxHeight: "calc(100vh - 200px)",
                                height: showModal.height ? showModal.height : "auto",
                                overflowY: "auto"
                            }, dangerouslySetInnerHTML: {
                                __html: showModal.content,
                            } }), _jsx("div", __assign({ className: "footer p-2 text-end" }, { children: showModal.confirm ? (_jsx(_Fragment, { children: showModal.confirm.sure && (_jsx("button", __assign({ id: "id_btnAgreementModalAccept", className: "btn " + (showModal.confirm.sure.class || "btn-success"), disabled: !hasScrolledToBottom, onClick: function () {
                                        if (showModal.confirm.sure.action) {
                                            showModal.confirm.sure.action();
                                        }
                                        if (showModal.confirm.sure.autoClose !== false) {
                                            closeModal();
                                        }
                                    } }, { children: hasScrolledToBottom ? (showModal.confirm.sure.label || "Kabul Ediyorum") : "Lütfen sonuna kadar okuyunuz" }))) })) : (_jsx("button", __assign({ className: "btn btn-secondary", onClick: closeModal }, { children: "Kapat" }))) }))] })), _jsx("div", { onClick: closeModal, className: "modal-backdrop show" })] }));
    }
    return _jsx(_Fragment, { children: props.children });
};
export default AgreementModal;
